var _rect, _rect2, _path, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 36,
    viewBox: "0 0 86 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#003CCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.458 16.846C53.458 17.7793 53.1033 18.5447 52.394 19.142C51.694 19.7393 50.7513 20.0753 49.566 20.15V22.474H54.578V23.37H43.532V22.474H48.502V20.15C47.326 20.066 46.388 19.73 45.688 19.142C44.988 18.5447 44.638 17.7793 44.638 16.846C44.638 15.838 45.0393 15.0307 45.842 14.424C46.654 13.8173 47.718 13.514 49.034 13.514C50.3687 13.514 51.4373 13.8173 52.24 14.424C53.052 15.0307 53.458 15.838 53.458 16.846ZM51.498 18.638C52.1233 18.19 52.436 17.5973 52.436 16.86C52.436 16.1227 52.128 15.53 51.512 15.082C50.896 14.634 50.07 14.41 49.034 14.41C48.0167 14.41 47.2 14.634 46.584 15.082C45.9773 15.53 45.674 16.1227 45.674 16.86C45.674 17.5973 45.9773 18.19 46.584 18.638C47.2 19.0767 48.0167 19.296 49.034 19.296C50.0607 19.296 50.882 19.0767 51.498 18.638ZM66.6913 18.722H55.6453V17.84H66.6913V18.722ZM65.7393 24.826H56.9753V21.844H64.1993V20.654H56.9753V19.8H65.2633V22.656H58.0533V23.958H65.7393V24.826ZM65.4033 16.762H57.1013V13.038H58.1653V15.88H65.4033V16.762Z",
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 35,
    rx: 17.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/Today.c4c5416e5c28712a3a8991cd2bad7790.svg";
export { ForwardRef as ReactComponent };